const React = require("react");

function ChartSquareBarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
  }));
}

module.exports = ChartSquareBarIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ChartSquareBarIcon.js
 ** module id = 465
 ** module chunks = 0
 **/